import * as types from '../../../actions/types';

const initialState = {
  mpid_stats: {},
};

export default function teachers (state = initialState, action) {
  switch (action.type) {
    case types.SET_DASHBOARD_DETAILS_TEACHERS:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
}
